import PlanejamentoAcaoFiltros from '../../../produto/spa/planejamento-acao/list/PlanejamentoAcaoFiltros';

export default PlanejamentoAcaoFiltros;
